import { logger } from "../services";

export const logCatch = (e: Error, namespace: string, methods: string): Error => {
  logger.error(`[${namespace}] ${methods} error`, { error: e.message });
  return e;
};
